import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  UploadOutlined, WarningOutlined, InfoCircleFilled,
  DownloadOutlined, EditOutlined,
  DeleteOutlined, ExclamationCircleOutlined,
} from '@ant-design/icons';
import {
  Card, Row, Col, Upload, Button, message,
  Input, InputNumber, Spin, TimePicker,
  Modal, notification, Form, Switch, Table,
} from 'antd';
import {
  get, put, post,
  isSuperAgentError,
  ResponseWrapper, RequestWrapper,
} from '../../../dataSource/requests';
import { downloadPDF, downloadArchive } from '../../../utils/helpers';
import './Parameters.scss';
import { SessionExpiredException } from '../../../utils/errors';
import { API_URL } from '../../../utils/constants';
import previewImageWeb from '../../../assets/images/preview_web.png';
import previewImageMobile from '../../../assets/images/preview_mobile.png';
import { formatTelephone } from '../../../utils/format';

const Parameters = (props): JSX.Element => {
  const [formInstance] = Form.useForm();
  const navigate = useNavigate();
  const [originalSystemParameters, setOriginalSystemParameters] = useState({});
  const [serviceParameters, setServiceParameters] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileTerm, setFileTerm] = useState([]);
  const [versionVigente, setVersionVigente] = useState('');
  const [imageFileList, setImageFileList] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const [linkValue, setLinkValue] = useState([]);
  const [linkAjudaValue, setLinkAjudaValue] = useState('');
  const [idValue, setIdValue] = useState('');
  const [targetImage, setTargetImage] = useState('');
  const [switchBannerValue, setSwitchBannerValue] = useState<boolean>(false);
  const [switchNewDocument, setSwitchNewDocument] = useState<boolean>(false);
  const [visibleModalResponsable, setvisibleModalResponsable] = useState<boolean>(false);
  const [historico, setHistorico] = useState([]);
  const [switchAjuda, setswitchAjuda] = useState<boolean>(false);
  const { confirm } = Modal;
  const titleSessionFormDocumentsAcceptance = useRef('Adicionar um novo documento de aceite');
  const interactionFormDocumentsAcceptance = useRef(false);
  const [arrDocumentsAcceptable, setArrDocumentsAcceptable] = useState([]);
  const [currentDocumentAccept, setCurrentDocumentAccept] = useState([]);
  const updateDocumentID = useRef(null);
  const updateDocumentIndice = useRef(null);
  const [state, setState] = useState<boolean>(true);

  const [loading, setLoading] = useState({
    active: false,
    text: '',
  });

  const convertSize = (type, size): number | null => {
    if (size === 0) {
      return 0;
    }

    if (type === 'byte') {
      return (size * 1048576);
    }

    if (type === 'mb') {
      return (size / 1048576);
    }

    return null;
  };

  const normalizeToApi = (parameters) => {
    return ({
      contactEmail: parameters.contactEmail,
      intervalSap: +parameters.intervalSap,
      serviceMaxPeriodOfDaysFilter: +parameters.serviceMaxPeriodOfDaysFilter,
      serviceRequestAlertEmail: parameters.serviceRequestAlertEmail,
      startTimeSap: moment(parameters.startTimeSap).format('YYYY-MM-DDTHH:mm:ss.SSS'),
      financialMaxPeriodOfDaysFilter: parameters.financialMaxPeriodOfDaysFilter != null ? parameters.financialMaxPeriodOfDaysFilter : '60',
      attachmentSizeCooperated: parameters.attachmentSizeCooperated,
      attachmentSizeCoopercitrus: parameters.attachmentSizeCoopercitrus,
      linkToHelp: parameters.linkToHelp != null ? parameters.linkToHelp : false,
      needHelp: parameters.needHelp,
      termsAndConditionsId: formInstance.getFieldValue('DocumentIdVigente') != ''
        ? formInstance.getFieldValue('DocumentIdVigente')
        : null,
      showPhone: parameters.showPhone || false,
      phone: parameters.showPhone ? `+55${parameters.phone}` : '',
      exclusionConfirmationEmail: parameters.exclusionConfirmationEmail,
      policyAndCookiesUrl: parameters.policyAndCookiesUrl,
      lgpdUrl: parameters.lgpdUrl,
    });
  };

  const normalizeFromApi = (parameters) => {
    return ({
      contactEmail: parameters.contactEmail,
      intervalSap: +parameters.intervalSap,
      serviceMaxPeriodOfDaysFilter: +parameters.serviceMaxPeriodOfDaysFilter,
      serviceRequestAlertEmail: parameters.serviceRequestAlertEmail,
      startTimeSap: moment(parameters.startTimeSap).utc().format('HH:mm'),
      termsAndConditions: parameters.termsAndConditions ? parameters.termsAndConditions.id : null,
      financialMaxPeriodOfDaysFilter: parameters.financialMaxPeriodOfDaysFilter != null ? parameters.financialMaxPeriodOfDaysFilter : '60',
      attachmentSizeCooperated: parameters.attachmentSizeCooperated,
      attachmentSizeCoopercitrus: parameters.attachmentSizeCoopercitrus,
      showPhone: parameters.showPhone || false,
      phone: parameters?.phone?.replace(/^\+55/, '') || undefined,
      exclusionConfirmationEmail: parameters.exclusionConfirmationEmail,
      policyAndCookiesUrl: parameters.policyAndCookiesUrl,
      lgpdUrl: parameters.lgpdUrl,
    });
  };

  const handleLoading = (active, text): void => {
    setLoading({ active, text });
  };

  const downloadFilee = async (fileId): Promise<void> => {
    const notificationArguments = {
      message: 'Notification Title',
      description: 'Description',
      icon: '',
    };

    let file;

    try {
      const downloadFileReqRef: RequestWrapper = get({
        url: `/file/downloadFile/${fileId}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      file = await downloadFileReqRef;
    } catch (error) {
      console.log(error);

      notificationArguments.message = 'Erro';
      notificationArguments.description = 'Não foi possivel fazer o download do arquivo';

      notification.open(notificationArguments);

      return;
    }

    if (file.status === 200) {
      const filee = new Blob([file.body], { type: 'application/pdf' });

      const a = document.createElement('a');
      const url = window.URL.createObjectURL(filee);

      a.href = url;
      a.download = `Termos e Condições ${fileId}`;

      document.body.append(a);

      a.click();

      setTimeout(() => {
        a.remove();
        window.URL.revokeObjectURL(url);
      }, 0);
    } else {
      notificationArguments.message = 'Erro';
      notificationArguments.description = 'Documento não encontrado.';
      notification.open(notificationArguments);
    }
  };

  const showNotification = (type): void => {
    const notificationArguments = {
      message: 'Notification Title',
      description: 'Description',
    };

    switch (type) {
      case 'ErrorSetSystemParameters':
        notificationArguments.message = 'Não foi possível concluir a operação';
        notificationArguments.description = 'Ocorreu um erro ao salvar os parâmetros do sistema.';
        notification.error(notificationArguments);
        break;

      case 'ErrorUploadFile':
        notificationArguments.message = 'Não foi possível concluir a operação';
        notificationArguments.description = 'Ocorreu um erro ao salvar o arquivo dos termos e condições de uso.';
        notification.error(notificationArguments);
        break;

      case 'ErrorUploadbanner':
        notificationArguments.message = 'Não foi possível concluir a operação';
        notificationArguments.description = 'Ocorreu um erro ao salvar as configurações do Banner.';
        notification.error(notificationArguments);
        break;

      case 'SuccessSetSystemParameters':
        notificationArguments.message = 'Operação concluída';
        notificationArguments.description = 'Parâmetros do sistema salvos com sucesso.';
        notification.success(notificationArguments);
        break;

      case 'ErrorGetSystemParameters':
        notificationArguments.message = 'Não foi possível concluir a requisição';
        notificationArguments.description = 'Ocorreu um erro ao buscar os parâmetros do sistema.';
        notification.error(notificationArguments);
        break;

      case 'SuccessUploadDocumentsAcceptance':
        notificationArguments.message = 'Operação concluída';
        notificationArguments.description = 'Documento(s) de aceite atualizado(s) com sucesso.';
        notification.success(notificationArguments);
        break;

      case 'ErrorUploadDocumentsAcceptance':
        notificationArguments.message = 'Não foi possível concluir a requisição';
        notificationArguments.description = 'Ocorreu um erro ao salvar o(s) arquivo(s) dos termos de aceite.';
        notification.error(notificationArguments);
        break;

      default:
        break;
    }
  };

  const switchNovo = (): void => {
    const val = formInstance.getFieldValue('novoDocumento');

    formInstance.setFieldsValue({ novoDocumento: !val });

    setSwitchNewDocument(!val);
  };

  const onSubmit = async (values): Promise<void> => {
    try {
      handleLoading(true, 'Salvando parâmetros...');
      values.attachmentSizeCooperated = convertSize('byte', values.attachmentSizeCooperated);
      values.attachmentSizeCoopercitrus = convertSize('byte', values.attachmentSizeCoopercitrus);

      if (switchBannerValue) {
        formInstance.validateFields();
        let dataBanner;

        try {
          if (imageFileList.length > 0) {
            const formData = new FormData();

            formData.append('file', imageFileList[0].originFileObj);
            formData.append('link', formInstance.getFieldValue('linkBanner'));

            const enableBannerReqRef: RequestWrapper = post({
              url: '/banner/enableBanner',

              params: formData,

              frontConfigs: {
                navigateFunction: navigate,
              },
            });

            await enableBannerReqRef;
          } else if (imageUrl !== '') {
            dataBanner = {
              bannerImageId: idValue,
              link: formInstance.getFieldValue('linkBanner'),
            };

            const setBannerParametersReqRef: RequestWrapper = put({
              params: dataBanner,
              url: '/banner/setBannerParameters',

              frontConfigs: {
                navigateFunction: navigate,
              },
            });

            await setBannerParametersReqRef;
          } else {
            handleLoading(false, '');

            return showNotification('ErrorUploadbanner');
          }
        } catch (error) {
          handleLoading(false, '');

          return showNotification('ErrorUploadbanner');
        }
      } else if (idValue !== '') {
        try {
          const dataBanner = {
            bannerParametersId: idValue,
          };

          const disableBannerReqRef: RequestWrapper = put({
            query: dataBanner,
            url: '/banner/disableBanner',

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await disableBannerReqRef;
        } catch (error) {
          handleLoading(false, '');

          return showNotification('ErrorUploadbanner');
        }
      }

      handleLoading(true, 'Salvando parâmetros...');

      let successfulRequestParameters = false;
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        if (values.policyAndCookiesUrl) {
          localStorage.setItem('policyAndCookiesUrl', values.policyAndCookiesUrl);
        } else {
          localStorage.setItem('policyAndCookiesUrl', 'https://coopercitrus.com.br/politica-de-privacidade');
        }
        if (values.lgpdUrl) {
          localStorage.setItem('lgpdUrl', values.lgpdUrl);
        } else {
          localStorage.setItem('lgpdUrl', 'https://coopercitrus.com.br/lgpd/');
        }
        const setSystemParametersReqRef: RequestWrapper = put({
          url: '/system/setSystemParameters',
          params: normalizeToApi({ ...values }),

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await setSystemParametersReqRef;

        if (response?.body.error) {
          showNotification('ErrorSetSystemParameters');
        }
      } catch (error) {
        if (!(error instanceof SessionExpiredException)) {
          showNotification('ErrorSetSystemParameters');
        }
      }

      let responseServices: ResponseWrapper | undefined;
      let responseServicesError: ResponseWrapper | undefined;
      let genericServicesError: Error | undefined;

      try {
        const setServiceBasicParametersReqRef: RequestWrapper = put({
          url: '/system/setServiceBasicParameters',

          params: {
            serviceParameters: Object.entries(values.serviceEmail)
              .map((svcValue) => {
                return ({
                  serviceId: svcValue[0].split('#$#')[1],
                  serviceRequestAlertEmail: svcValue[1],
                  minimumAmountOfHectares: values.serviceMaxHectare[svcValue[0]],
                });
              }),
          },

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        responseServices = await setServiceBasicParametersReqRef;

        if (responseServices.error || responseServices.body.error) {
          showNotification('ErrorSetSystemParameters');
        } else {
          successfulRequestParameters = true;

          showNotification('SuccessSetSystemParameters');
        }
      } catch (error) {
        if (!(error instanceof SessionExpiredException)) {
          showNotification('ErrorSetSystemParameters');
        }
      }

      handleLoading(false, '');

      if (successfulRequestParameters) {
        navigate('/home');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isUrl = (rule, str): Promise<void> => {
    const regexp = /^(?:http(s)?:\/\/)+[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

    if (regexp.test(str)) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Link inválido'));
  };

  const onCancel = (): void => {
    const formValues = normalizeFromApi({
      ...formInstance.getFieldsValue(),
      termsAndConditions: fileList.length ? fileList[0] : null,
    });

    // Condição que verifica se houve alterações no formulário.
    if (JSON.stringify(originalSystemParameters) === JSON.stringify(formValues)) {
      navigate('/home');
    } else {
      Modal.confirm({
        title: 'Os dados alterados serão perdidos!',
        content: 'Tem certeza que deseja cancelar?',
        okText: 'Sim, cancelar sem salvar',
        cancelText: 'Não',
        autoFocusButton: null,
        icon: (<WarningOutlined />),
        onOk: () => navigate('/home'),
      });
    }
  };

  const getParametersCall = async (): Promise<ResponseWrapper | undefined> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const getSystemParameters: RequestWrapper = get({
        url: '/system/getSystemParameters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await getSystemParameters;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        showNotification('ErrorGetSystemParameters');
        handleLoading(false, '');
        return undefined;
      }

      handleLoading(false, '');
      return undefined;
    }

    return response;
  };

  const handleConfirmArquivo = (): void => {
    Modal.confirm({
      title: 'Atenção',
      content: 'Ao confirmar, esse novo documento passará a ser vigente e exigirá um novo aceite de todos os usuários cooperados do sistema. Confirma?',
      okText: 'Sim',
      cancelText: 'Não',
      autoFocusButton: null,

      onOk: () => {
        const up = async (): Promise<void> => {
          let response: ResponseWrapper | undefined;
          let responseError: ResponseWrapper | undefined;
          let genericError: Error | undefined;

          const formData = new FormData();
          formData.append('file', fileList[0].originFileObj);
          formData.append('version ', formInstance.getFieldValue('versaoArquivo') != undefined
            ? formInstance.getFieldValue('versaoArquivo')
            : '');

          try {
            const uploadTermsReqRef: RequestWrapper = post({
              url: '/file/uploadTermsAndConditionsFile',

              params: formData,

              frontConfigs: {
                navigateFunction: navigate,
              },
            });

            response = await uploadTermsReqRef;

            if (response?.body.error) {
              showNotification('ErrorGetSystemParameters');
            }

            if (!response.error) {
              response = await getParametersCall();
              const newFileList = [];

              if (response?.body.getSystemParametersOutput.termsAndConditions) {
                newFileList.push({
                  id: response?.body
                    .getSystemParametersOutput
                    .termsAndConditions
                    .id,

                  name: response?.body
                    .getSystemParametersOutput
                    .termsAndConditions
                    .name,

                  size: response?.body
                    .getSystemParametersOutput
                    .termsAndConditions
                    .size,

                  registrationDate: response?.body
                    .getSystemParametersOutput
                    .termsAndConditions
                    .registrationDate,

                  version: response?.body
                    .getSystemParametersOutput
                    .termsAndConditions
                    .version,

                  status: 'done',
                  type: 'application/pdf',
                  uid: 'rc-upload-1588789561844-9',
                });
              }

              setFileTerm(newFileList);
              setVersionVigente(newFileList[0]?.version);

              formInstance.setFieldsValue({
                versaoArquivoVigente: newFileList[0]?.version ? newFileList[0]?.version : '',

                dataHoraInsercaoVigente: newFileList[0]?.registrationDate,

                DocumentIdVigente: newFileList[0]?.id,
                versaoArquivo: '',
              });

              setFileList([]);
              switchNovo();

              const notificationArguments = {
                message: 'Notification Title',
                description: 'Description',
                icon: '',
              };

              notificationArguments.message = 'operação concluída';
              notificationArguments.description = 'Novo arquivo de termos e condições de uso salvo.';

              notification.success(notificationArguments);
              handleLoading(false, '');
            }
          } catch (error) {
            if (!(error instanceof SessionExpiredException)) {
              showNotification('ErrorUploadFile');
            }

            handleLoading(false, '');
          }

          handleLoading(false, '');
        };

        handleLoading(true, '');
        up();
        handleLoading(false, '');
      },
    });
  };

  const handleChangeFile = ({ file, fileList }) => {
    const fileSizeByte = convertSize('byte', formInstance.getFieldValue('attachmentSizeCoopercitrus'));

    if (file.size > fileSizeByte) {
      return message.error(`O arquivo ultrapassou ${formInstance.getFieldValue('attachmentSizeCoopercitrus')} MB`);
    }

    if (!file.type.includes('pdf')) {
      return message.error('Insira um arquivo do tipo PDF');
    }

    const newFileList = fileList.length === 0 ? null : fileList[fileList.length - 1];

    setFileList(newFileList ? [newFileList] : []);
    return undefined;
  };

  const handleChangeImageFile = (info): void => {
    if (info.file.status === 'removed') {
      setImageFileList([]);
      setTargetImage('');
      return;
    }

    if (info.file.size > 4000000) {
      message.error('O arquivo ultrapassou 4 MB');
      return;
    }

    if (!info.file.type.includes('png') && !info.file.type.includes('jpg') && !info.file.type.includes('jpeg')) {
      message.error('Insira um arquivo de tipo válido');
      return;
    }

    const newFileList = [info.file];
    setImageFileList(newFileList);
  };

  const getTermsOfAcceptance = async (): Promise<void> => {
    let docsAcceptableResponse: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const getTermsOfAcceptanceReqRef: RequestWrapper = get({
        url: '/file/getTermsOfAcceptance',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      docsAcceptableResponse = await getTermsOfAcceptanceReqRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (docsAcceptableResponse?.body?.code === 9012):
        // "Terms of acceptance found successfully", 9012
        setArrDocumentsAcceptable(docsAcceptableResponse?.body.terms);
        break;

      case (responseError?.body?.code === -9017):
        // "Terms of acceptance list is empty", -9017
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        setArrDocumentsAcceptable([]);
        handleLoading(false, '');
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        setArrDocumentsAcceptable([]);
        handleLoading(false, '');
        break;
    }
  };

  useEffect(() => {
    return () => {
      setState(false);
    };
  }, []);

  useEffect(() => {
    const getSystemParameters = async (): Promise<void> => {
      handleLoading(true, 'Carregando parâmetros...');

      let response;
      let BannerResponse;

      try {
        const getBannerParametersReqRef: RequestWrapper = get({
          url: '/banner/getBannerParameters',

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        BannerResponse = await getBannerParametersReqRef;
      } catch (error) {
        if (!(error instanceof SessionExpiredException)) {
          showNotification('ErrorGetSystemParameters');
          handleLoading(false, '');
          return;
        }

        handleLoading(false, '');
        return;
      }
      if (BannerResponse?.body.bannerParametersOutput != null && BannerResponse?.body.bannerParametersOutput.imageUrl !== '') {
        const imageUrlLocal = `${API_URL}${BannerResponse?.body.bannerParametersOutput.imageUrl}`;

        setImageUrl(imageUrlLocal);
        setLinkValue(BannerResponse?.body.bannerParametersOutput.link);
        setIdValue(BannerResponse?.body.bannerParametersOutput.id);
        setTargetImage(imageUrlLocal);
        setSwitchBannerValue(true);

        formInstance.setFieldsValue({
          linkBanner: BannerResponse?.body.bannerParametersOutput.link,
        });
        formInstance.setFieldsValue({ switchBanner: true });
      }

      response = await getParametersCall();

      const newFileList = [];

      if (response?.body.error) {
        showNotification('ErrorGetSystemParameters');
      }

      if (response?.body.getSystemParametersOutput.termsAndConditions) {
        newFileList.push({
          id: response?.body
            .getSystemParametersOutput
            .termsAndConditions
            .id,

          name: response?.body
            .getSystemParametersOutput
            .termsAndConditions
            .name,

          size: response?.body
            .getSystemParametersOutput
            .termsAndConditions
            .size,

          registrationDate: response?.body
            .getSystemParametersOutput
            .termsAndConditions
            .registrationDate,

          version: response?.body
            .getSystemParametersOutput
            .termsAndConditions
            .version,

          status: 'done',
          type: 'application/pdf',
          uid: 'rc-upload-1588789561844-9',
        });
      }

      setOriginalSystemParameters(normalizeFromApi(response?.body.getSystemParametersOutput));
      setFileTerm(newFileList);
      setVersionVigente(newFileList[0]?.version);

      formInstance.setFieldsValue({
        serviceMaxPeriodOfDaysFilter: response?.body
          .getSystemParametersOutput
          .serviceMaxPeriodOfDaysFilter,

        contactEmail: response?.body
          .getSystemParametersOutput
          .contactEmail,

        showPhone: response?.body
          .getSystemParametersOutput
          .showPhone,

        phone: formatTelephone(response?.body
          .getSystemParametersOutput
          ?.phone?.replace(/^\+55/, '')) || undefined,

        exclusionConfirmationEmail: response?.body
          .getSystemParametersOutput?.exclusionConfirmationEmail || '',

        policyAndCookiesUrl: response?.body
          .getSystemParametersOutput?.policyAndCookiesUrl || '',

        lgpdUrl: response?.body
          .getSystemParametersOutput?.lgpdUrl || '',

        needHelp: response?.body
          .getSystemParametersOutput
          .needHelp,

        linkToHelp: response?.body
          .getSystemParametersOutput
          .linkToHelp == 'false' ? ''
          : response?.body
            .getSystemParametersOutput
            .linkToHelp,

        intervalSap: response?.body
          .getSystemParametersOutput
          .intervalSap,

        serviceRequestAlertEmail: response?.body
          .getSystemParametersOutput
          .serviceRequestAlertEmail,

        startTimeSap: moment(response?.body
          .getSystemParametersOutput
          .startTimeSap)
          .utc(),

        financialMaxPeriodOfDaysFilter: response?.body
          .getSystemParametersOutput
          .financialMaxPeriodOfDaysFilter,

        attachmentSizeCooperated: convertSize('mb', response?.body
          .getSystemParametersOutput
          .attachmentSizeCooperated),

        attachmentSizeCoopercitrus: convertSize('mb', response?.body
          .getSystemParametersOutput
          .attachmentSizeCoopercitrus),

        versaoArquivoVigente: newFileList[0]?.version ? newFileList[0]?.version : '',

        dataHoraInsercaoVigente: newFileList[0]?.registrationDate,

        DocumentIdVigente: newFileList[0]?.id,
      });

      if (response?.body.getSystemParametersOutput.needHelp) {
        setswitchAjuda(response?.body.getSystemParametersOutput.needHelp);
        setLinkAjudaValue(response?.body.getSystemParametersOutput.linkToHelp);
      }

      handleLoading(false, '');
    };

    const getServiceParameters = async (): Promise<void> => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const getServiceBasicParametersReqRef: RequestWrapper = get({
          url: '/system/getServiceBasicParameters',

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await getServiceBasicParametersReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 8004):
          // "Services parameters got successfully", 8004
          setServiceParameters(response?.body.getServicesParametersOutput.serviceParameters);
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;

        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;

        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;

        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Houve um erro ao executar sua solicitação.',
          });
          break;
      }
    };

    getSystemParameters();
    getServiceParameters();
    getTermsOfAcceptance();
  }, [props]);

  useEffect(() => {
    const loadUploadedImagePreview = (): void => {
      if (imageFileList.length > 0) {
        const reader = new FileReader();

        reader.readAsDataURL(imageFileList[0]?.originFileObj);
        reader.onloadend = (): void => {
          setTargetImage(reader.result);
        };
      }
    };

    loadUploadedImagePreview();
  }, [imageFileList]);

  const onchangeSwitchBanner = (): void => {
    const value = formInstance.getFieldValue('switchBanner');
    setSwitchBannerValue(value);
  };
  const onchangeSwitchAjuda = (): void => {
    const value = formInstance.getFieldValue('needHelp');
    setswitchAjuda(value);
  };

  const columns = [
    {
      title: <div className="table-titles"> ID do documento</div>,
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: <div className="table-titles">Data/hora da solicitação</div>,
      dataIndex: 'registrationDate',
      key: 'registrationDate',
      render: (date) => (date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : ''),
    },
    {
      title: <div className="table-titles"> Versão</div>,
      dataIndex: 'version',
      key: 'version',
    },
    {
      title: <div className="table-titles"> Arquivo</div>,
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: <div className="table-titles">Ações</div>,
      dataIndex: 'id',
      key: 'id',
      render: (key): JSX.Element => {
        return (
          <DownloadOutlined
            style={{ cursor: 'pointer' }}
            onClick={
              async (): Promise<void> => {
                await downloadFilee(key);
              }
            }
          />
        );
      },
    },
  ];

  const interactionFormTermsAcceptance = (documentID, documentIndice): void => {
    interactionFormDocumentsAcceptance.current = true;
    updateDocumentID.current = documentID;
    updateDocumentIndice.current = documentIndice;

    if (updateDocumentID.current !== null) {
      titleSessionFormDocumentsAcceptance.current = 'Atualizar o documento de aceite';

      setCurrentDocumentAccept([arrDocumentsAcceptable[documentIndice].file]);

      formInstance.setFieldsValue({ inputFileName: arrDocumentsAcceptable[documentIndice].name });
    } else {
      titleSessionFormDocumentsAcceptance.current = 'Adicionar um novo documento de aceite';

      setCurrentDocumentAccept([]);

      formInstance.setFieldsValue({ inputFileName: '' });
    }
  };

  const handleDownloadDocumentAcceptance = async (id, name): Promise<void> => {
    const notificationArguments = {
      message: 'Notification Title',
      description: 'Description',
      icon: '',
    };

    let file;
    let url;
    url = `/file/downloadTermsOfAcceptance/${id}`;

    try {
      const downloadTermsReqRef: RequestWrapper = get({
        url,

        frontConfigs: {
          navigateFunction: navigate,
        },

        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },

        responseType: 'blob',
      });

      file = await downloadTermsReqRef;
    } catch (error) {
      notificationArguments.message = 'Erro';
      notificationArguments.description = 'Não foi possivel fazer o download do arquivo';
      notification.open(notificationArguments);

      return;
    }

    if (file.status === 200) {
      const filee = new Blob([file.body], { type: 'application/pdf' });
      const a = document.createElement('a');
      const urlLocal = window.URL.createObjectURL(filee);

      a.href = urlLocal;
      a.download = !name ? 'Termos e Condições' : name;
      document.body.append(a);
      a.click();

      setTimeout(() => {
        a.remove();
        window.URL.revokeObjectURL(urlLocal);
      }, 0);
    } else {
      notificationArguments.message = 'Erro';
      notificationArguments.description = 'Documento não encontrado.';
      notification.open(notificationArguments);
    }
  };

  const uploadFileDocumentAcceptance = async (sendApiTermsOfAcceptance): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append(
        'newTermsOfAcceptance',
        sendApiTermsOfAcceptance.newTermsOfAcceptance.originFileObj,
      );

      const uploadTermsReqRef: RequestWrapper = post({
        url: '/file/uploadTermsOfAcceptanceFiles',

        params: formData,

        query: {
          termsOfAcceptanceNameList: sendApiTermsOfAcceptance.termsOfAcceptanceNameList,
        },

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const responseDocsAcceptable = await uploadTermsReqRef;

      if (responseDocsAcceptable?.body.error) {
        showNotification('ErrorUploadDocumentsAcceptance');
        handleLoading(false, '');
      } else {
        getTermsOfAcceptance();
        showNotification('SuccessUploadDocumentsAcceptance');
        handleLoading(false, '');
      }
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        showNotification('ErrorUploadDocumentsAcceptance');
        handleLoading(false, '');
      }
    }
  };

  const editFileDocumentAcceptance = async (sendApiTermsOfAcceptance): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('newTermsOfAcceptance', sendApiTermsOfAcceptance.newTermsOfAcceptance.originFileObj);

      const editTermsReqRef: RequestWrapper = put({
        url: '/file/editTermsOfAcceptance',

        params: formData,

        query: {
          termsOfAcceptanceId: sendApiTermsOfAcceptance.termsOfAcceptanceId,
          termsOfAcceptanceName: sendApiTermsOfAcceptance.termsOfAcceptanceNameList,
        },

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const responseDocsAcceptable = await editTermsReqRef;

      if (responseDocsAcceptable.error) {
        showNotification('ErrorUploadDocumentsAcceptance');
        handleLoading(false, '');
      } else {
        getTermsOfAcceptance();
        showNotification('SuccessUploadDocumentsAcceptance');
        handleLoading(false, '');
      }
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        showNotification('ErrorUploadDocumentsAcceptance');
        handleLoading(false, '');
      }
    }
  };

  const handleSaveTermsAcceptance = (): boolean | undefined => {
    formInstance.validateFields();

    if (
      currentDocumentAccept.length === 0
      || formInstance.getFieldValue('inputFileName') === '') {
      return false;
    }

    const arrDocuments = arrDocumentsAcceptable;

    if (updateDocumentID.current !== null) {
      if (arrDocuments[updateDocumentIndice.current].name !== formInstance.getFieldValue('inputFileName')) {
        arrDocuments[updateDocumentIndice.current].name = formInstance.getFieldValue('inputFileName');
      }
      if (arrDocuments[updateDocumentIndice.current].file.name !== currentDocumentAccept[0].name) {
        arrDocuments[updateDocumentIndice.current].file.name = currentDocumentAccept[0].name;
      }
      setArrDocumentsAcceptable(arrDocuments);

      const objDoc = {
        id: updateDocumentID.current,
        name: arrDocuments[updateDocumentIndice.current].name,
        file: { ...currentDocumentAccept[0] },
      };

      const sendApiTermsOfAcceptance = {
        termsOfAcceptanceId: objDoc.id,
        termsOfAcceptanceNameList: [objDoc.name],
        newTermsOfAcceptance: objDoc.file,
      };

      editFileDocumentAcceptance(sendApiTermsOfAcceptance);
    } else {
      setArrDocumentsAcceptable(
        [
          ...arrDocumentsAcceptable,
          {
            id: null,
            name: document.querySelector('#inputFileName').value,
            file: { ...currentDocumentAccept[0] },
          },
        ],
      );

      const objDoc = {
        id: null,
        name: document.querySelector('#inputFileName').value,
        file: { ...currentDocumentAccept[0] },
      };

      const sendApiTermsOfAcceptance = {
        termsOfAcceptanceNameList: [encodeURIComponent(objDoc.name)],
        newTermsOfAcceptance: objDoc.file,
      };

      uploadFileDocumentAcceptance(sendApiTermsOfAcceptance);
    }

    updateDocumentID.current = null;
    updateDocumentIndice.current = null;
    interactionFormDocumentsAcceptance.current = false;
  };

  const handleCancelTermsAcceptance = (): void => {
    interactionFormDocumentsAcceptance.current = false;
    setCurrentDocumentAccept([]);
    formInstance.setFieldsValue({ inputFileName: '' });
  };

  const deleteFileDocumentAcceptance = async (sendApiTermsOfAcceptance): Promise<void> => {
    try {
      const deleteTermsReqRef: RequestWrapper = put({
        url: 'file/deleteTermsOfAcceptance',

        query: {
          termsOfAcceptanceId: sendApiTermsOfAcceptance.termsOfAcceptanceId,
        },

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const responseDocsAcceptable = await deleteTermsReqRef;

      if (responseDocsAcceptable?.body.error) {
        showNotification('ErrorUploadDocumentsAcceptance');
        handleLoading(false, '');
      } else {
        getTermsOfAcceptance();
        showNotification('SuccessUploadDocumentsAcceptance');
        handleLoading(false, '');
      }
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        showNotification('ErrorUploadDocumentsAcceptance');
        handleLoading(false, '');
      }
    }
  };

  const handleDeleteTermsAcceptance = (documentID): void => {
    const sendApiTermsOfAcceptance = {
      termsOfAcceptanceId: documentID,
    };

    confirm({
      title: 'O termo de aceite será excluído!',
      icon: <ExclamationCircleOutlined />,
      content: 'Tem certeza que deseja excluir?',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Não',

      onOk() {
        deleteFileDocumentAcceptance(sendApiTermsOfAcceptance);
      },

      onCancel() {
        console.log('Cancel');
      },
    });

    updateDocumentID.current = null;
    updateDocumentIndice.current = null;
    interactionFormDocumentsAcceptance.current = false;
  };

  const handleChangeFileDocumentsAcceptable = ({ file }) => {
    const fileSizeByte = convertSize('byte', formInstance.getFieldValue('attachmentSizeCoopercitrus'));

    if (file.size > fileSizeByte) {
      return message.error(`O arquivo ultrapassou ${formInstance.getFieldValue('attachmentSizeCoopercitrus')} MB`);
    }

    if (!file.type.includes('pdf')) {
      return message.error('Insira um arquivo do tipo PDF');
    }

    if (file.status === 'removed') file = null;
    const newFileList = file === null ? null : file;
    if (newFileList) {
      setCurrentDocumentAccept([newFileList]);
    } else {
      setCurrentDocumentAccept(null);
    }

    return undefined;
  };

  return (
    <div className="Parameters">
      <Modal
        className="modalHist"
        width="750px"
        title={<h3 style={{ margin: 0, width: '70vw' }}>Histórico de documentos</h3>}
        visible={visibleModalResponsable}
        onCancel={
          (): void => {
            setvisibleModalResponsable(false);
          }
        }
        footer={[]}
      >
        <Table
          rowKey="actionDate"
          columns={columns}
          dataSource={historico}
          pagination={false}
        />
      </Modal>
      <Spin tip={loading.text} spinning={loading.active}>
        <Form
          scrollToFirstError
          form={formInstance}
          layout="vertical"
          initialValues={{
            whichPreview: false,
          }}
          onFinish={onSubmit}
          onFinishFailed={
            (errorInfo): void => {
              console.log('Parameters onFinishFailed', errorInfo);
            }
          }
        >
          <div>
            <Row gutter={24} className="row-header">
              <Col xs={{ span: 24 }} md={{ span: 14 }}>
                <span className="service-title">Parâmetros do sistema</span>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 10 }} className="button-col">
                <Button
                  type="primary"
                  className="button-cancel"
                  onClick={
                    (): void => {
                      onCancel();
                    }
                  }
                >
                  Cancelar
                </Button>
                <Form.Item
                  noStyle
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="button-save"
                  >
                    Salvar
                  </Button>
                </Form.Item>
              </Col>
            </Row>
            <Card
              title={<b>Parâmetros gerais</b>}
              bordered={false}
              className="parameters-card"
            >
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                  <Form.Item label="Termos e condições de uso">
                    <Row>Documento vigente</Row>
                    <Row gutter={24}>
                      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 5 }}>
                        <Form.Item
                          label="ID do documento"
                          name="DocumentIdVigente"
                        >
                          {formInstance.getFieldValue('DocumentIdVigente')}
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 5 }}>
                        <Form.Item
                          label="Data / hora da inserção"
                          name="dataHoraInsercaoVigente"
                        >
                          {
                            (formInstance.getFieldValue('dataHoraInsercaoVigente')
                              ? moment(formInstance.getFieldValue('dataHoraInsercaoVigente'))
                                .format('DD/MM/YYYY [às] HH:mm') : '')
                          }
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 5 }}>
                        <Form.Item
                          label="Versão:"
                          name="versaoArquivoVigente"
                          initialValue={versionVigente}
                        >
                          {versionVigente}
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 5 }}>
                        <Form.Item
                          label="Arquivo"
                          name="arquivoVigente"
                        >
                          <Upload
                            method="get"
                            accept=".pdf,application/pdf"
                            onChange={handleChangeFile}
                            fileList={fileTerm}
                            onDownload={downloadPDF}
                            disabled
                          >
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 4 }}>
                        <Form.Item
                          label="Ações:"
                          name="acoes"
                        >
                          <Row>
                            <DownloadOutlined
                              style={{ cursor: 'pointer' }}
                              onClick={
                                async (): Promise<void> => {
                                  await downloadFilee(formInstance.getFieldValue('DocumentIdVigente'));
                                }
                              }
                            />
                          </Row>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="end" gutter={24}>
                      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                        <Form.Item
                          noStyle
                        >
                          <Button
                            type="primary"
                            className="button-save"
                            onClick={
                              (): void => {
                                const getHistorico = async (): Promise<void> => {
                                  let response: ResponseWrapper | undefined;
                                  let responseError: ResponseWrapper | undefined;
                                  let genericError: Error | undefined;

                                  try {
                                    const termsHistoryReqRef: RequestWrapper = get({
                                      url: '/file/gethistoricOfTermsAndConditions',

                                      frontConfigs: {
                                        navigateFunction: navigate,
                                      },
                                    });

                                    response = await termsHistoryReqRef;
                                  } catch (error) {
                                    if (!(error instanceof SessionExpiredException)) {
                                      showNotification('ErrorGetSystemParameters');
                                      handleLoading(false, '');
                                      return;
                                    }
                                  }

                                  if (!response?.body.error) {
                                    const orderBy = (files): any => {
                                      files.sort((a, b) => {
                                        if (a.registrationDate > b.registrationDate) {
                                          return -1;
                                        }

                                        if (a.registrationDate < b.registrationDate) {
                                          return 1;
                                        }

                                        return 0;
                                      });

                                      return files;
                                    };

                                    const f = orderBy(response?.body.files);
                                    setHistorico(f);
                                    setvisibleModalResponsable(true);
                                  }
                                };

                                getHistorico();
                              }
                            }
                          >
                            Histórico de Documentos
                          </Button>
                        </Form.Item>
                        <Form.Item
                          noStyle
                          name="novoDocumento"
                          initialValue={false}
                        >
                          <Button
                            type="primary"
                            className={
                              !switchNewDocument
                                ? 'button-save'
                                : 'button-cancel-new'
                            }
                            onClick={
                              (): void => {
                                switchNovo();
                              }
                            }
                          >
                            Novo Documento
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                    {
                      switchNewDocument
                        ? (
                          <>
                            <Row>Adicionar um novo documento</Row>
                            <Row gutter={24}>
                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }}>
                                <Form.Item
                                  label="ID do documento"
                                  name="DocumentId"
                                >
                                  <Input disabled />
                                </Form.Item>
                              </Col>
                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }}>
                                <Form.Item
                                  label="Data / hora da inserção"
                                  name="dataHoraInsercao"
                                >
                                  <Input disabled />
                                </Form.Item>
                              </Col>
                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }}>
                                <Form.Item
                                  label="Versão:"
                                  name="versaoArquivo"
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }}>
                                <Form.Item
                                  label="Arquivo"
                                  name="arquivo"
                                >
                                  <Upload
                                    method="get"
                                    accept=".pdf,application/pdf"
                                    onChange={handleChangeFile}
                                    fileList={fileList}
                                    onDownload={downloadPDF}
                                  >
                                    <Button>
                                      <UploadOutlined />
                                      Carregar arquivo
                                    </Button>
                                  </Upload>
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row justify="end" gutter={24}>
                              <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }}>
                                <Button
                                  type="primary"
                                  className="button-cancel"
                                  onClick={
                                    (): void => {
                                      switchNovo();
                                    }
                                  }
                                >
                                  Cancelar
                                </Button>
                                <Form.Item
                                  noStyle
                                >
                                  <Button
                                    type="primary"
                                    className="button-save"
                                    onClick={
                                      (): void => {
                                        handleConfirmArquivo();
                                      }
                                    }
                                  >
                                    Salvar
                                  </Button>
                                </Form.Item>
                              </Col>
                            </Row>
                          </>
                        ) : null
                    }
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                  <Form.Item
                    label="E-mail para contato"
                    name="contactEmail"
                    rules={
                      [
                        {
                          required: true,
                          message: 'Por favor, informe um e-mail',
                        },
                        {
                          type: 'email',
                          message: 'E-mail inválido',
                        },
                      ]
                    }
                  >
                    <Input
                      autoComplete="email"
                      placeholder="Digite o e-mail"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item label="Precisa de ajuda?" name="needHelp">
                    <Switch
                      checked={switchAjuda}
                      onChange={
                        onchangeSwitchAjuda
                      }
                    />
                  </Form.Item>
                </Col>
                {
                  switchAjuda
                    ? (
                      <Col xs={{ span: 12 }}>
                        <Form.Item
                          label="Link"
                          name="linkToHelp"
                          rules={
                            [
                              {
                                required: true,
                                message: 'Por favor, informe um Link',
                              },
                              {
                                validator: isUrl,
                                message: 'Link inválido',
                              },
                            ]
                          }
                        >
                          <Input
                            type="text"
                            placeholder="Digite o Link"
                            value={linkAjudaValue}
                          />
                        </Form.Item>
                      </Col>
                    ) : null
                }
              </Row>
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Habilitar botão do WhatsApp?"
                    name="showPhone"
                    valuePropName="checked"
                  >
                    <Switch
                      title="Habilitar botão do WhatsApp?"
                    />
                  </Form.Item>
                </Col>
                <Form.Item
                  noStyle
                  shouldUpdate={
                    (prevValue, curValue): boolean => {
                      return prevValue.showPhone !== curValue.showPhone;
                    }
                  }

                >
                  {
                    (formInstanceParameter): JSX.Element | null => {
                      if (formInstanceParameter.getFieldValue('showPhone') === true) {
                        return (
                          <Col xs={{ span: 12 }}>
                            <Form.Item
                              name="phone"
                              label="Celular com WhatsApp"
                              rules={[
                                {
                                  required: true,
                                  message: 'O telefone é obrigatorio',
                                },
                                {
                                  max: 15,
                                  min: 14,
                                  message: 'O telefone com o DDD deve ter entre 10 ou 11 digitos.',
                                },
                              ]}
                              getValueFromEvent={
                                (eventt): string => {
                                  return formatTelephone(eventt.target.value);
                                }
                              }
                            >
                              <Input
                                placeholder="Telefone com DDD"
                                className="ant-input"
                                maxLength={15}
                              />
                            </Form.Item>
                          </Col>
                        );
                      }

                      return null;
                    }
                  }
                </Form.Item>
              </Row>
            </Card>

            <Card
              title={<b>Documentos de aceite</b>}
              bordered={false}
              className="parameters-card"
            >
              {
                arrDocumentsAcceptable.length > 0
                  ? arrDocumentsAcceptable.map((i, indice) => {
                    return (
                      <Row key={i.id} gutter={24} style={{ marginTop: '1rem' }}>
                        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'start',
                              flexDirection: 'column',
                            }}
                          >
                            <span className="ant-form-item-greencooper">Nome de exibição:</span>
                            <span style={{ fontSize: '.85rem', wordBreak: 'break-all' }}>{i.name}</span>
                          </div>
                        </Col>

                        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'start',
                              flexDirection: 'column',
                            }}
                          >
                            <span className="ant-form-item-greencooper">Documento:</span>
                            <span style={{ fontStyle: 'italic', fontSize: '.85rem', wordBreak: 'break-all' }}>{i.file.name}</span>
                          </div>
                        </Col>

                        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 2 }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start',
                              flexDirection: 'column',
                            }}
                          >
                            <span className="ant-form-item-greencooper">Ações:</span>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                flexDirection: 'row',
                              }}
                            >
                              <Button
                                icon={<DownloadOutlined />}
                                className="btn-action"
                                onClick={
                                  (): void => {
                                    handleDownloadDocumentAcceptance(i.file.id, i.name);
                                  }
                                }
                              />
                              <Button
                                icon={<EditOutlined />}
                                className="btn-action"
                                onClick={
                                  (): void => {
                                    interactionFormTermsAcceptance(i.id, indice);
                                  }
                                }
                              />
                              <Button
                                icon={<DeleteOutlined />}
                                className="btn-action"
                                onClick={
                                  (): void => {
                                    handleDeleteTermsAcceptance(i.id);
                                  }
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })
                  : (
                    <div style={{ marginBottom: '.7rem' }}>
                      <span style={{ fontStyle: 'italic' }}>Nenhum documento de aceite adicionado.</span>
                    </div>
                  )
              }

              <div style={{ margin: '1rem 0', width: '100%', textAlign: 'right' }}>
                <Button
                  className="button-save"
                  type="primary"
                  onClick={
                    (): void => {
                      interactionFormTermsAcceptance(null, null);
                    }
                  }
                >
                  Adicionar um documento
                </Button>
              </div>

              {
                interactionFormDocumentsAcceptance.current === true
                  ? (
                    <div style={{ borderTop: '1px solid #f0f0f0' }}>
                      <p style={{ padding: '.7rem 0', fontWeight: 'bold' }} className="ant-form-item-greencooper">{titleSessionFormDocumentsAcceptance.current}</p>

                      <Row gutter={24} style={{ margin: 'auto 0 0 0' }}>
                        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 5 }}>
                          <Form.Item label="Documento">
                            <Upload
                              id="docFile"
                              method="get"
                              accept=".pdf,application/pdf"
                              onChange={
                                (e): void => {
                                  handleChangeFileDocumentsAcceptable(e);
                                }
                              }
                              fileList={currentDocumentAccept}
                            >
                              <Button>
                                <UploadOutlined />
                                Carregar arquivo
                              </Button>
                            </Upload>
                          </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 19 }}>
                          <Form.Item
                            label="Nome de exibição"
                            name="inputFileName"
                            id="inputFileName"
                          >
                            <Input
                              maxLength="236"
                              placeholder="Digite um nome"
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <div style={{ textAlign: 'right', width: '100%', marginBottom: '1rem' }}>
                        <Button
                          type="primary"
                          className="button-cancel"
                          onClick={handleCancelTermsAcceptance}
                        >
                          Cancelar
                        </Button>
                        <Button
                          type="primary"
                          className="button-save"
                          onClick={handleSaveTermsAcceptance}
                        >
                          Salvar
                        </Button>
                      </div>
                    </div>
                  )
                  : <></>
              }
            </Card>

            <Card title={<b>Serviços</b>} bordered={false} className="parameters-card">
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                  <Form.Item
                    label="Limite do filtro de período"
                  >
                    <Form.Item
                      noStyle
                      name="serviceMaxPeriodOfDaysFilter"
                      rules={
                        [
                          {
                            required: true,
                            message: 'Por favor, informe um período',
                          },
                        ]
                      }
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        aplaceholder="Período"
                      />
                    </Form.Item>
                    <span> Dias</span>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                  <Form.Item
                    label="E-mails para avisos de novas solicitações"
                  >
                    {
                      serviceParameters.length
                        ? serviceParameters.map((value) => {
                          return (
                            <Form.Item
                              key={value.id}
                              label={value.serviceName}
                              name={['serviceEmail', `${value.serviceName}#$#${value.id}`]}
                              initialValue={value.serviceRequestAlertEmail}
                              rules={
                                [
                                  {
                                    required: true,
                                    message: 'Por favor, informe um e-mail',
                                  },
                                  {
                                    type: 'email',
                                    message: 'E-mail inválido',
                                  },
                                ]
                              }
                            >
                              <Input
                                autoComplete="email"
                                placeholder="Digite o e-mail"
                              />
                            </Form.Item>
                          );
                        })
                        : null
                    }
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                  <Form.Item
                    label="Quantidade mínima de hectares para as solicitações"
                  >
                    {
                      serviceParameters.length
                        ? serviceParameters.map((value) => {
                          return (
                            <Form.Item
                              key={value.id}
                              label={value.serviceName}
                              name={['serviceMaxHectare', `${value.serviceName}#$#${value.id}`]}
                              initialValue={value.minimumAmountOfHectares}
                              rules={
                                [
                                  {
                                    required: true,
                                    message: 'Por favor, informe um valor mínimo',
                                  },
                                  {
                                    type: 'integer',
                                    message: 'valor inválido',
                                  },
                                ]
                              }
                            >
                              <InputNumber
                                className="maxHectareInput"
                                placeholder="Digite o valor"
                                min={0}
                              />
                            </Form.Item>
                          );
                        })
                        : null
                    }
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card title={<b>Financeiro</b>} bordered={false} className="parameters-card">
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                  <Form.Item
                    label="Limite do filtro de período"
                  >
                    <Form.Item
                      name="financialMaxPeriodOfDaysFilter"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor, informe um período',
                        },
                      ]}
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        aplaceholder="Período"
                      />
                    </Form.Item>
                    <span> Dias</span>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              title={<b>Carga de dados do SAP</b>}
              bordered={false}
              className="parameters-card"
            >
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item
                    label="Horário de início"
                    name="startTimeSap"
                    rules={
                      [
                        {
                          required: true,
                          message: 'Por favor, informe um horário',
                        },
                      ]
                    }
                  >
                    <TimePicker format="HH:mm" placeholder="00:00" />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                  <Form.Item
                    label="Intervalo"
                  >
                    <Form.Item
                      name="intervalSap"
                      rules={
                        [
                          {
                            required: true,
                            message: 'Por favor, informe a qtd. de horas',
                          },
                        ]
                      }
                      noStyle
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        aplaceholder="Qtd. de horas"
                      />
                    </Form.Item>
                    <span> Horas</span>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card title={<b>Anexos</b>} bordered={false} className="parameters-card">
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item label="Tamanho máximo de anexos para Cooperados">
                    <Form.Item
                      name="attachmentSizeCooperated"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor, informe um limite',
                        },
                      ]}
                      noStyle
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        aplaceholder="Limite"
                      />
                    </Form.Item>
                    <span> MB</span>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
                  <Form.Item label="Tamanho máximo de anexos para Coopercitrus">
                    <Form.Item
                      name="attachmentSizeCoopercitrus"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor, informe um limite',
                        },
                      ]}
                      noStyle
                    >
                      <InputNumber
                        min={1}
                        precision={0}
                        aplaceholder="Limite"
                      />
                    </Form.Item>
                    <span> MB</span>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card
              title={<b>Banner de divulgação</b>}
              bordered={false}
              className="parameters-card"
            >
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                  <Form.Item label="Habilitar banner na tela inicial" name="switchBanner" valuePropName="checked">
                    <Switch
                      onChange={
                        onchangeSwitchBanner
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              {
                switchBannerValue
                  ? (
                    <>
                      <Row gutter={[8, 36]}>
                        <Col xs={{ span: 24 }}>
                          <div className="zeroAdvise">
                            <p className="textoVerde">
                              <InfoCircleFilled className="icon" />
                              {' Requisitos da imagem:'}
                              <br />
                              - Proporções: idealmente 16x9 ou 4x3;
                              <br />
                              - Limite de tamanho do arquivo: até 4MB
                              <br />
                              - Formato: png, jpg ou jpeg
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row gutter={[8, 36]}>
                        <Col xs={{ span: 12 }}>
                          <Form.Item name="banner" label="Imagem">
                            <Upload
                              method="get"
                              accept=".jpg, .jpeg, .png"
                              fileList={imageFileList}
                              onChange={handleChangeImageFile}
                              onDownload={downloadArchive}
                            >
                              <Button>
                                <UploadOutlined />
                                Carregar arquivo
                              </Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 12 }}>
                          <Form.Item
                            label="Link"
                            name="linkBanner"
                            rules={
                              [
                                {
                                  required: true,
                                  message: 'Por favor, informe um Link',
                                },
                                {
                                  validator: isUrl,
                                  message: 'Link inválido',
                                },
                              ]
                            }
                          >
                            <Input
                              type="text"
                              placeholder="Digite o Link"
                              value={linkValue}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Item
                            name="whichPreview"
                            valuePropName="checked"
                            label="Preview"
                          >
                            <Switch
                              unCheckedChildren="Web"
                              checkedChildren="App"
                              title="Preview"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={[8, 36]}>
                        <Col xs={{ span: 24 }}>
                          <Form.Item
                            shouldUpdate
                          >
                            {
                              (formInstanceParameter): JSX.Element => {
                                switch (true) {
                                  case (formInstanceParameter.getFieldValue('whichPreview')):
                                    // preview do app
                                    return (
                                      <div className="Parameters__ImageStack">
                                        <img
                                          alt=" "
                                          className="Parameters__ImageStack__BottomImage Parameters__ImageStack__BottomImage--App"
                                          src={previewImageMobile}
                                        />
                                        {
                                          targetImage
                                            ? (
                                              <img
                                                alt=" "
                                                className="Parameters__ImageStack__TopImage Parameters__ImageStack__TopImage--App"
                                                src={targetImage}
                                              />
                                            )
                                            : null
                                        }
                                      </div>
                                    );

                                  case (formInstanceParameter.getFieldValue('whichPreview') === false):
                                  default:
                                    // preview do web
                                    return (
                                      <div className="Parameters__ImageStackWeb">
                                        <img
                                          alt=" "
                                          className="Parameters__ImageStackWeb__BottomImage"
                                          src={previewImageWeb}
                                        />
                                        {
                                          targetImage
                                            ? (
                                              <img
                                                alt=" "
                                                className="Parameters__ImageStackWeb__TopImage Web"
                                                src={targetImage}
                                              />
                                            )
                                            : null
                                        }

                                        {/* <Image
                                            className="Parameters__ImageStack__BottomImage"
                                            src={previewImageWeb}
                                            preview={false}
                                          />
                                          <Image
                                            className="Parameters__ImageStack__TopImage"
                                            src={targetImage}
                                            preview={false}
                                          /> */}
                                      </div>
                                    );
                                }
                              }
                            }
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ) : null
              }
            </Card>
            <Card
              title={<b>Solicitação de exclusão de conta</b>}
              bordered={false}
              className="parameters-card"
            >
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                  <Form.Item
                    key="exclusionConfirmationEmail"
                    label="E-mail que será notificado quando um usuário solicitar a exclusão de sua conta no Campo Digital"
                    name="exclusionConfirmationEmail"
                    rules={[{ type: 'email', message: 'E-mail inválido' }]}
                  >
                    <Input autoComplete="email" placeholder="Digite o e-mail" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card
              title={<b>Política de privacidade e cookies e LGPD</b>}
              bordered={false}
              className="parameters-card"
            >
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                  <Form.Item
                    key="policyAndCookiesUrl"
                    label="URL para as políticas de privacidade e cookies"
                    name="policyAndCookiesUrl"
                    rules={[{ type: 'url', message: 'URL inválida' }]}
                  >
                    <Input placeholder="Digite a URL para as políticas de privacidade e cookies" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                  <Form.Item
                    key="lgpdUrl"
                    label="URL para as políticas de LGPD"
                    name="lgpdUrl"
                    rules={[{ type: 'url', message: 'URL inválida' }]}
                  >
                    <Input placeholder="Digite a URL para as políticas de LGPD" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

Parameters.propTypes = {};
Parameters.defaultProps = {};

export default Parameters;
